import { useState } from "react";

/**
 * Hook to copy text to clipboard
 * @returns Tuple of [copiedText, copy function]
 */
export function useCopyToClipboard(): [
  string | null,
  (text: string) => Promise<void>
] {
  const [copiedText, setCopiedText] = useState<string | null>(null);

  const copy = async (text: string) => {
    if (!navigator?.clipboard) {
      console.warn("Clipboard not supported");
      return;
    }

    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
    } catch (error) {
      console.error("Failed to copy text: ", error);
      setCopiedText(null);
    }
  };

  return [copiedText, copy];
}

